import { createAction, props } from '@ngrx/store';

export const downloadOrdersCsv = createAction('[Orders] Download Orders CSV');

export const downloadOrdersCsvSuccess = createAction('[Orders] Download Orders CSV Success', props<{ data: any }>());

export const downloadOrdersCsvFailure = createAction('[Orders] Download Orders CSV Failure', props<{ error: any }>());
